document.addEventListener('DOMContentLoaded', function () {
  const categorySelect = document.getElementById('filter-category');
  const tagSelect = document.getElementById('filter-tag');
  const items = document.querySelectorAll('.blog-listing__item');
  const pagination = document.querySelector('.pagination');

  const BLOG_HANDLE = 'all';

  function handleize(value) {
    return value
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');
  }

  const params = new URLSearchParams(window.location.search);

  // Restore selected values from URL params
  if (categorySelect && params.get('category')) {
    categorySelect.value = params.get('category');
  }

  if (tagSelect && params.get('tag')) {
    tagSelect.value = params.get('tag');
  }

  // Detect Shopify /tagged/ URLs
  if (!params.get('category') && !params.get('tag')) {
    const pathMatch = window.location.pathname.match(/\/tagged\/(.+)/);

    if (pathMatch) {
      const tagsFromUrl = pathMatch[1].split('+');

      tagsFromUrl.forEach(tag => {
        if (tag.startsWith('category-') && categorySelect) {
          categorySelect.value = tag.replace('category-', '');
        }

        if (tagSelect) {
          [...tagSelect.options].forEach(option => {
            if (handleize(option.value) === tag) {
              tagSelect.value = option.value;
            }
          });
        }
      });
    }
  }

  // No results UI handler
  function toggleNoResults(count) {
    let noResults = document.querySelector('.blog-no-results');
    const container = document.querySelector('.blog-listing__container');

    if (count === 0) {
      if (!noResults && container) {
        noResults = document.createElement('div');
        noResults.className = 'blog-no-results';
        noResults.innerHTML = '<p>No articles found.</p>';
        container.appendChild(noResults);
      }

      if (pagination) pagination.style.display = 'none';
    } else {
      if (noResults) noResults.remove();
      if (pagination) pagination.style.display = '';
    }
  }

  // Clear button visibility
  function toggleClearButtons() {
    document
      .querySelectorAll('.blog-listing__filter')
      .forEach(filter => filter.classList.remove('is-active'));

    if (categorySelect?.value) {
      categorySelect.closest('.blog-listing__filter')
        .classList.add('is-active');
    }

    if (tagSelect?.value) {
      tagSelect.closest('.blog-listing__filter')
        .classList.add('is-active');
    }
  }

  function applyFilters() {
    const selectedCategory = categorySelect?.value || '';
    const selectedTag = tagSelect?.value || '';

    const tags = [];

    if (selectedCategory) {
      tags.push(`category-${handleize(selectedCategory)}`);
    }

    if (selectedTag) {
      tags.push(handleize(selectedTag));
    }

    let url = `/blogs/${BLOG_HANDLE}`;

    if (tags.length) {
      url += `/tagged/${tags.join('+')}`;
    }

    window.location.href = url;
  }

  categorySelect?.addEventListener('change', applyFilters);
  tagSelect?.addEventListener('change', applyFilters);

  document.querySelectorAll('.blog-listing__clear-filter').forEach(btn => {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
    
      const clearType = this.dataset.clear;
    
      let selectedCategory = categorySelect?.value || '';
      let selectedTag = tagSelect?.value || '';
    
      if (clearType === 'category') {
        selectedCategory = '';
      }
    
      if (clearType === 'tag') {
        selectedTag = '';
      }
    
      const tags = [];
    
      if (selectedCategory) {
        tags.push(`category-${handleize(selectedCategory)}`);
      }
    
      if (selectedTag) {
        tags.push(handleize(selectedTag));
      }
    
      let url = `/blogs/${BLOG_HANDLE}`;
    
      if (tags.length) {
        url += `/tagged/${tags.join('+')}`;
      }
    
      window.location.href = url;
    });
  });


  // Running UI state even if zero results
  toggleClearButtons();
  toggleNoResults(items.length);
});
